// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSaveSiteDefaultResponse {
    static getAttributeTypeMap() {
        return AccountSaveSiteDefaultResponse.attributeTypeMap;
    }
}
AccountSaveSiteDefaultResponse.discriminator = undefined;
AccountSaveSiteDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    }
];
//# sourceMappingURL=accountSaveSiteDefaultResponse.js.map